define('plugin/static-page/controller/StaticPageController',['require','lib/controller/BaseController','Config','plugin/static-page/view/PageView','lib/view/ModalRegion','lib/plugin/PluginBroker'],function (require) {

    var BaseController = require('lib/controller/BaseController');
   // var ClientModel = require('model/ClientModel');
    var Config = require('Config');

    var PageView = require('plugin/static-page/view/PageView');

    var ModalRegion = require('lib/view/ModalRegion');
    var PluginBroker = require('lib/plugin/PluginBroker');

    /**
     * Static Page Controller
     *
     * @class StaticPageController
     */
    return BaseController.extend({

        _name : 'StaticPageController',

        _model: null,
        _collection: null,
        _view: null,

        initialize: function () {
            this._collection = this.getOption('pagesCollection');
            BaseController.prototype.initialize.call(this);
        },
        /**
         * indexId action, display index view in content region
         */
        indexId: function(pageid, router) {
            this._view = new PageView({
                model: this._collection._getPageModel(pageid),
            });

            this.getMainLayout().getContentRegion().show(this._view);
        },
        /**
         * index action, display index view in content region
         */
        index: function(page, router) {
            this._view = new PageView({
                model: this._collection._getPageModelBySeoUrl(page),
            });

            this.getMainLayout().getContentRegion().show(this._view);
        },


    });

});

